import { ProductDetailPageResult } from "../ProductDetailPageResult";

export default ({
  youMayAlsoNeedCarouselItems,
  customersAlsoViewedCarouselItems,
  otherProductsFromThisLine,
  sideBySideProductCompareItem,
}: ProductDetailPageResult) => {
  const youMayAlsoNeedCarouselItemNumbers = youMayAlsoNeedCarouselItems.map(
    (x) => x.itemNumber,
  );

  const customersAlsoViewedCarouselItemNumbers =
    customersAlsoViewedCarouselItems.map((x) => x.itemNumber);

  const otherProductsFromThisLineCarouselItemNumbers =
    otherProductsFromThisLine.map((x) => x.itemNumber);

  let recommendedSimilarItemNumber: string[] = [];
  if (
    sideBySideProductCompareItem?.isRecommendedSimilarItem &&
    sideBySideProductCompareItem?.compareProductItemNumber
  ) {
    recommendedSimilarItemNumber = [
      sideBySideProductCompareItem.compareProductItemNumber,
    ];
  }

  return [
    ...youMayAlsoNeedCarouselItemNumbers,
    ...customersAlsoViewedCarouselItemNumbers,
    ...otherProductsFromThisLineCarouselItemNumbers,
    ...recommendedSimilarItemNumber,
  ];
};
